import React from 'react'
import { useGoal } from 'gatsby-plugin-fathom'
import { SocialContainer, SocialWrapper, SocialTitle } from './Social.styles'
import Icon from '../Icon'

const Social = () => {
  const handleGithub = useGoal('CF19QYQD')
  const handleLinkedIn = useGoal('MOXSHCLG')
  const socials = [
    {
      name: 'Github',
      url: 'https://github.yago.dev',
      icon: 'github-alt',
      color: 'github',
      event: handleGithub,
    },
    {
      name: 'LinkedIn',
      url: 'https://linkedin.yago.dev',
      icon: 'linkedin-in',
      color: 'linkedin',
      event: handleLinkedIn,
    },
  ]
  return (
    <SocialContainer padded>
      {socials.map(({ icon, color, url, name, event }) => (
        <SocialWrapper brand={color} href={url} key={name} onClick={event}>
          <Icon icon={icon} iconType="fab" />
          <SocialTitle>{name}</SocialTitle>
        </SocialWrapper>
      ))}
    </SocialContainer>
  )
}

export default Social
